"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContextOrderTypeTypeToJSON = exports.AppContextOrderTypeTypeFromJSONTyped = exports.AppContextOrderTypeTypeFromJSON = exports.AppContextOrderTypeType = void 0;
/**
 *
 * @export
 */
exports.AppContextOrderTypeType = {
    Standard: 0,
    Refinement: 1
};
function AppContextOrderTypeTypeFromJSON(json) {
    return AppContextOrderTypeTypeFromJSONTyped(json, false);
}
exports.AppContextOrderTypeTypeFromJSON = AppContextOrderTypeTypeFromJSON;
function AppContextOrderTypeTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AppContextOrderTypeTypeFromJSONTyped = AppContextOrderTypeTypeFromJSONTyped;
function AppContextOrderTypeTypeToJSON(value) {
    return value;
}
exports.AppContextOrderTypeTypeToJSON = AppContextOrderTypeTypeToJSON;
